<input #fileInput
       type="file"
       style="display: none;"
       (change)="onImageChange($event)"/>

<div class="simple-card"
     [style.--border-color]="topic.color"
     [class.low-opacity]="!isTracker && !localContent && !isFocused">

  <div class="entry-header">
    <app-styled-topic [topic]="topic"
                      class="entry-header__topic topic-matched-borders topic-button mr-10"
                      style="font-size: 20px;"
                      [routerLink]="['/topics', topic.id]">
    </app-styled-topic>
    <div class="entry-header__buttons">
<!--      <ion-button *ngIf="showTimer"-->
<!--                  fill="clear"-->
<!--                  (click)="timerVisible = !timerVisible">-->
<!--        <ion-icon slot="icon-only" name="timer-outline"></ion-icon>-->
<!--      </ion-button>-->

      <ion-button *ngIf="!imageProcessing"
                  color="medium"
                  fill="clear"
                  (click)="addImageToEntry()">
        <ion-icon slot="icon-only" name="image-outline"></ion-icon>
      </ion-button>
      <ion-spinner *ngIf="imageProcessing"
                   name="dots"
                   style="width: 25px; height: 25px;">
      </ion-spinner>

      <ion-button *ngIf="localContent === null"
                  color="medium"
                  fill="clear"
                  (click)="showInputAndFocus()">
        <ion-icon slot="icon-only" name="create-outline">
        </ion-icon>
      </ion-button>
      <ion-button *ngIf="!isTracker && showBookmark"
                  color="medium"
                  fill="clear"
                  (click)="toggleTopicIsPinned()">
        <ion-icon slot="icon-only"
                  [name]="'bookmark' + (topic.is_pinned ? '' : '-outline')">
        </ion-icon>
      </ion-button>
<!--      <ion-button *ngIf="showBloglink"-->
<!--                  fill="clear"-->
<!--                  [routerLink]="['/topics', topic.id]">-->
<!--        <ion-icon slot="icon-only" name="open-outline">-->
<!--        </ion-icon>-->
<!--      </ion-button>-->
    </div>
  </div>


  <div class="ion-padding">

    <app-timer *ngIf="timerVisible"
               [name]="topic.name">
    </app-timer>


    <ion-row *ngIf="isTracker">
      <ion-col>
        <ion-range class="ion-no-padding"
                   [(ngModel)]="localValue"
                   step="0.05"
                   [snaps]="true"
                   min="0"
                   max="1"
                   [pin]="true"
                   [pinFormatter]="pinFormatter"
                   [color]="{entry, topic} | rangeTrackerColor"
                   (ionChange)="this.debouncedSave.next()">
        </ion-range>
      </ion-col>
    </ion-row>

    <ion-row *ngIf="planning">
      <ion-col size="auto">
        {{planning.startDate | date: 'shortTime'}}
        -
        {{planning.endDate | date: 'shortTime'}}
      </ion-col>
      <ion-col size="auto">
        {{planning.description}}
      </ion-col>
    </ion-row>

    <ng-container *ngIf="localContent !== null">
      <ion-textarea [(ngModel)]="localContent"
                    class="mt-10"
                    fill="outline"
                    [rows]="rows"
                    [autoGrow]="true"
                    (paste)="onPaste($event)"
                    (ionFocus)="editorFocused.emit(topic.id)"
                    (ionBlur)="onInputBlur()">
      </ion-textarea>

      <ion-row class="ion-justify-content-between ion-align-items-center ion-no-padding mt-10">
        <ion-col size="auto" class="ion-no-padding">

        </ion-col>
        <ion-col size="auto" class="ion-no-padding">

          <ion-button *ngIf="unsavedChanges"
                      color="medium"
                      fill="outline"
                      size="small">
            speichern
          </ion-button>


          <ion-button
            color="danger"
            fill="clear"
            size="small"
            (click)="removeEntry()">
            <ion-icon slot="icon-only" name="trash-outline"></ion-icon>
          </ion-button>
        </ion-col>
      </ion-row>
    </ng-container>

  </div>
</div>
